export default ({axios, mapQueryString, withoutInvalidValues}) => ({
    list: (query = {}) => axios.get(`/bookings${mapQueryString(withoutInvalidValues(query))}`),
    show: (id, query = {}) => axios.get(`/bookings/${id}${mapQueryString(query)}`),
    store: (id, body = {}) => axios.post(`/foodies/${id}/bookings`, body),
    update: (id, body) => axios.patch(`/bookings/${id}`, withoutInvalidValues(body)),
    delete: (id) => axios.delete(`/bookings/${id}`),
    cancel: (id) => axios.patch(`/bookings/${id}/cancel`),
})
